import React, { Component } from 'react';
import { Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import DrawsTable from './components/DrawsTable';
import { connect } from "react-redux";
import { viewDisbursementAction, getRecipients, resetWinners } from '../actions/disbursement.actions';

class DrawView extends Component { 
    componentDidMount() {
        const { raffleId, id } = this.props.location.state;
        this.props.dispatch(viewDisbursementAction(raffleId))
        this.props.dispatch(getRecipients({ pageNum: 1, pageSize: 10, batchId: id, searchKey: "" }))
    }
    fetchData = (params) => {
        this.props.dispatch(getRecipients(params))
    }
    reload = () => {
        const { raffleId } = this.props.location.state;
        this.props.dispatch(viewDisbursementAction(raffleId))
    }
    capitalize = (s) => {
        if (typeof s !== "string") return s;
        return s.charAt(0).toUpperCase() + s.slice(1);
      };
      componentWillUnmount () {
          this.props.dispatch(resetWinners());
      }
    render () {

        return (
            <Col md={12} lg={12}>
                <Card>
                    <CardBody>
                        <div className="card__title">
                            <h5 className="bold-text">
                                <Link to="/disbursement" id="link-all-disbursements">
                                    <MdArrowBack size={20} /> Back to disbursement
                                </Link>
                            </h5>
                        </div>
                        <br />
                        <div>
                            <DrawsTable dataSource={this.props.winnerDisbursement} fetchData={this.fetchData} />
                        </div>
                    </CardBody>
                </Card>
            </Col>
        );
    }
};


export default connect((state) => ({
    viewDisbursement: state.viewDisbursement,
    winnerDisbursement: state.winnerDisbursement
}))(DrawView);
